"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TestStripIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6835 1.99651H7.99649V22.0335H16.6835V1.99651ZM9.94349 20.0865V3.94351H14.7365V20.0865H9.94349ZM11.77 10.68C11.93 10.52 12.13 10.44 12.34 10.44C12.55 10.44 12.76 10.52 12.92 10.68C13.24 11 13.24 11.51 12.92 11.83C12.76 11.99 12.56 12.07 12.35 12.07C12.14 12.07 11.93 11.99 11.77 11.83C11.45 11.51 11.45 11 11.77 10.68ZM12.34 5.16C12.13 5.16 11.93 5.24 11.77 5.4C11.45 5.72 11.45 6.23 11.77 6.55C11.93 6.7 12.14 6.78 12.34 6.78C12.55 6.78 12.75 6.7 12.91 6.54C13.23 6.22 13.23 5.71 12.91 5.39C12.76 5.24 12.55 5.16 12.34 5.16ZM11.77 8.04C11.93 7.88 12.13 7.8 12.34 7.8C12.55 7.8 12.76 7.88 12.92 8.04C13.24 8.36 13.24 8.87 12.92 9.19C12.76 9.35 12.56 9.43 12.35 9.43C12.14 9.43 11.93 9.35 11.77 9.19C11.45 8.87 11.45 8.36 11.77 8.04Z",
  fill: "currentColor"
}));

var _default = TestStripIcon;
exports.default = _default;